// @flow
import React, { Fragment } from 'react';
import type { ProductSequence } from 'store/modules/products';
import { resizeImage, numberWithCommas } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';

import cx from 'classnames';

import './ProductSequences.scss';

type ProductSequenceItemProps = {
  sequence: ProductSequence,
  username: string,
  active: boolean,
  thumbnail: string,
};

type Props = {
  sequences: ?(ProductSequence[]),
  username: string,
  supplier: string,
  currentProductId: string,
  displayName: string,
};

const ProductSequenceItem = ({
  sequence,
  username,
  active,
  thumbnail,
}: ProductSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/products/${url_slug}`;

  return (
    <Link className={cx('product-sequence-card', { active })} to={to}>
      <div className="product-sequence-image">
        {thumbnail ? (
          <img src={resizeImage(thumbnail, 150, 150)} alt={title} />
        ) : (
          <div className="product-sequence-placeholder">
            <span role="img" aria-label="상품이미지">
              📦
            </span>
          </div>
        )}
      </div>

      <div className="product-sequence-content">
        {meta.supplier && <p className="product-sequence-brand">{meta.supplier}</p>}
        <h4 className="product-sequence-title">{title}</h4>
        {!!(meta.price && meta.price !== '0' && meta.price !== 0) && (
          <p className="product-sequence-price">{numberWithCommas(meta.price)}원</p>
        )}
      </div>
    </Link>
  );
};

const ProductSequences = ({
  sequences,
  username,
  supplier,
  displayName,
  currentProductId,
}: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="ProductSequences">
      <div className="product-sequences-header">
        <h3>
          <span role="img" aria-label="브랜드상품">
            🏷️
          </span>
          <Link to={`/products/tags/${supplier}`} className="supplier-name">
            {supplier}
          </Link>{' '}
          상품 둘러보기
        </h3>
        <p>동일 브랜드의 다른 상품들을 확인해보세요</p>
      </div>

      <div className="product-sequences-grid">
        {sequences.map(s => (
          <ProductSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentProductId}
            thumbnail={s.thumbnail}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductSequences;



// WEBPACK FOOTER //
// ./src/components/product/ProductSequences/ProductSequences.js